// extracted by mini-css-extract-plugin
module.exports = {"link":"_6bc6d6a0","imageWrapper":"_c656cd4","image":"_534c88a7","title":"_f013dc0"};